/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_Keep_RegisterInputs */

const id_reseller_pricing_keep_register = /** @type {(inputs: Reseller_Pricing_Keep_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLD yang aktif harus punya harga jual registrasi. Nonaktifkan dulu untuk menghapusnya.`)
};

const en_reseller_pricing_keep_register = /** @type {(inputs: Reseller_Pricing_Keep_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A TLD on sale needs a registration price. Take it off sale first to remove it.`)
};

/**
* | output |
* | --- |
* | "A TLD on sale needs a registration price. Take it off sale first to remove it." |
*
* @param {Reseller_Pricing_Keep_RegisterInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_keep_register = /** @type {((inputs?: Reseller_Pricing_Keep_RegisterInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Keep_RegisterInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_keep_register(inputs)
	return id_reseller_pricing_keep_register(inputs)
});